module.exports = "/_next/static/images/a68fa234d9702935ff727d1666a319cd-roxinho-basicos-flutuantes-lg@2x.png";